module.exports = __webpack_public_path__ + "img/cambio-tipografia.e5ef6c8d.svg";